module.exports = __webpack_public_path__ + "img/2.878d772e.jpg";